























































































































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import { EnumsApi } from '@/api';
import { Actor } from '@types';

import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import LocationSelects from '@/components/.global/LocationSelects.vue';

export default Vue.extend({
    name: 'Form',

    components: {
        PageHeader,
        LocationSelects,
    },

    data() {
        return {
            state: 'idle',
            formData: <Actor.ProfileFormData>{},
            phonesDirty: false,
            phonesValid: false,
            locationsDirty: false,
        };
    },

    created() {
        this.setFormData();
    },

    mounted() {
        this.$validator.validateAll();
    },

    methods: {
        ...mapActions(['whoAmI']),

        setFormData() {
            this.formData = this.getActor.getProfileData();
        },

        onPhoneInput(response: any) {
            this.phonesDirty = response.isDirty;
            this.phonesValid = response.isValid;
        },

        onLocationsUpdate(value: any) {
            if (value === null || value?.type?.slug == 'county') {
                this.locationsDirty = true;
            }
        },

        async submit() {
            if (!this.isValid || this.state == 'saving') {
                return false;
            }
            this.state = 'saving';
            const oldData = this.getActor.getProfileData();
            this.getActor.setProfileData(this.formData);
            try {
                await this.getActor.saveProfile();
                this.state = 'saved';
                this.$store.dispatch('whoAmI').then(() => this.setFormData());
            } catch (e) {
                this.$env.log.error(e);
                this.$bugsnag.notify(e);
                this.state = 'error';
                this.getActor.setProfileData(oldData);
            } finally {
                setTimeout(() => {
                    this.state = 'idle';
                }, 2000);
            }
        },
    },

    computed: {
        ...mapGetters(['getActor']),

        locationValid() {
            return !this.location || this.location.type.slug == 'county';
        },

        isDirty(): boolean {
            return (
                Object.values(this.fields).some((field: any) => field.dirty) || this.phonesDirty || this.locationsDirty
            );
        },

        isValid(): boolean {
            return (
                Object.values(this.fields).every((field: any) => field.valid) && this.phonesValid && this.locationValid
            );
        },

        isSubmittable() {
            return this.isValid && this.isDirty;
        },

        location: {
            get() {
                return this.formData.locations[0] || null;
            },
            set(val) {
                this.formData.locations = val ? [val] : [];
            },
        },
    },

    watch: {
        state(newVal) {
            switch (newVal) {
                case 'idle':
                    break;
                case 'saving':
                    this.$refs.submitBtn.setLoading();
                    break;
                case 'saved':
                    this.$refs.submitBtn.setSuccess('Success');
                    break;
                case 'error':
                    this.$refs.submitBtn.setError('Failed');
                    break;
            }
        },
    },
});
